import { render, staticRenderFns } from "./FeatureConfig.vue?vue&type=template&id=bc53879c&"
import script from "./FeatureConfig.vue?vue&type=script&lang=js&"
export * from "./FeatureConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports